import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { CartDrawer } from "@/components/site/CartDrawer";
import Home from "@/pages/Home";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentResult";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <SmoothScroll>
          <div className="mth-root">
            <div className="grain" aria-hidden="true" />
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
            <CartDrawer />
            <Toaster theme="dark" position="bottom-center" />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
